<div class="historial-container">
  <div class="header-actions">
    <h1>Historial de Inventario</h1>
  </div>

  <!-- Filtros -->
  <mat-card class="filtros-card">
    <mat-card-content>
      <form [formGroup]="filtroForm" class="filtros-form">
        <mat-form-field appearance="outline">
          <mat-label>Fecha inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fecha fin</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Tipo de movimiento</mat-label>
          <mat-select formControlName="tipo">
            <mat-option *ngFor="let t of tiposMovimiento" [value]="t.value">{{ t.label }}</mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Búsqueda de producto -->
        <div class="producto-search-wrap">
          <mat-form-field appearance="outline">
            <mat-label>Filtrar por producto</mat-label>
            <input matInput
              [value]="busquedaProducto"
              (input)="buscarProducto($any($event.target).value)"
              placeholder="Buscar...">
            <button matSuffix mat-icon-button *ngIf="productoSeleccionado" (click)="limpiarProducto()" matTooltip="Limpiar">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <div *ngIf="productosResultados.length" class="autocomplete-panel">
            <div *ngFor="let p of productosResultados" class="autocomplete-item" (click)="seleccionarProducto(p)">
              <span class="p-nombre">{{ p.nombre }}</span>
              <span class="p-codigo">{{ p.codigo }}</span>
            </div>
          </div>
        </div>

        <button mat-flat-button color="primary" (click)="cargarMovimientos(0)" [disabled]="isLoading">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Tabla -->
  <mat-card class="table-card">
    <mat-card-content>
      <div *ngIf="isLoading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando historial...</p>
      </div>

      <div *ngIf="!isLoading && movimientos.length === 0" class="empty-state">
        <mat-icon>inventory</mat-icon>
        <h3>Sin movimientos</h3>
        <p>No hay movimientos de inventario para el filtro seleccionado.</p>
      </div>

      <div *ngIf="!isLoading && movimientos.length > 0" class="table-wrapper">
        <table mat-table [dataSource]="movimientos" class="historial-table">

          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let m">
              {{ m.createdAt | date:'dd/MM/yy HH:mm' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="producto">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let m">
              <span class="prod-nombre">{{ m.producto?.nombre || '—' }}</span>
              <span class="prod-codigo" *ngIf="m.producto?.codigo">{{ m.producto.codigo }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="tipo">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let m">
              <span class="tipo-badge" [ngClass]="tipoClass(m.tipoMovimiento)">
                {{ tipoLabel(m.tipoMovimiento) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="anterior">
            <th mat-header-cell *matHeaderCellDef>Stock Ant.</th>
            <td mat-cell *matCellDef="let m">{{ m.cantidadAnterior }}</td>
          </ng-container>

          <ng-container matColumnDef="cambio">
            <th mat-header-cell *matHeaderCellDef>Cambio</th>
            <td mat-cell *matCellDef="let m">
              <span class="cambio-value" [ngClass]="cambioClass(m.cantidadCambio)">
                {{ formatCambio(m.cantidadCambio) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="nuevo">
            <th mat-header-cell *matHeaderCellDef>Stock Nuevo</th>
            <td mat-cell *matCellDef="let m">{{ m.cantidadNueva }}</td>
          </ng-container>

          <ng-container matColumnDef="referencia">
            <th mat-header-cell *matHeaderCellDef>Referencia</th>
            <td mat-cell *matCellDef="let m">
              <span *ngIf="m.referenciaTipo" class="ref-text">{{ m.referenciaTipo }} #{{ m.referenciaId }}</span>
              <span *ngIf="!m.referenciaTipo">—</span>
              <span *ngIf="m.observaciones" class="obs-text" [matTooltip]="m.observaciones">
                <mat-icon style="font-size:14px;height:14px;width:14px;">notes</mat-icon>
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 25, 50, 100]"
          (page)="onPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>
